import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams, OpalApiRequestBodyFile } from '../../schema'

type CreateGemFileV3Params = OpalApiRequestParams<'CreateGemFileV3'>
type CreateGemFileV3RequestBody = OpalApiRequestBodyFile<'CreateGemFileV3'>

export const createGemFile = async (
  params: CreateGemFileV3Params,
  requestBody: CreateGemFileV3RequestBody
) => {
  const url = new URL('/opal_ai/v3/gem_files/', window.location.origin)

  return HttpClient()
    .post(url.toString(), requestBody, {
      headers: { 'Content-Type': 'application/octet-stream', ...params.header },
    })
    .then((res) => res.data)
}
